import { StepLabel, styled } from "@mui/material";

const CustomStepLabel = styled(StepLabel)({
    flexDirection: "column",
    "& .MuiStepLabel-labelContainer": {
      marginTop: "5px",
    },
  });

export default CustomStepLabel;